export const serviceMapLabelPresets = {
  CN: {
    dx: 18,
    dy: -12,
    anchor: 'start'
  },
  HK: {
    dx: 12,
    dy: 6,
    anchor: 'start'
  },
  MO: {
    dx: 10,
    dy: 14,
    anchor: 'start'
  },
  TW: {
    dx: 12,
    dy: 6,
    anchor: 'start'
  },
  JP: {
    dx: 12,
    dy: 0,
    anchor: 'start'
  },
  KR: {
    dx: 12,
    dy: -10,
    anchor: 'start'
  },
  SG: {
    dx: 14,
    dy: 12,
    anchor: 'start'
  },
  MY: {
    dx: -14,
    dy: 10,
    anchor: 'end'
  },
  PH: {
    dx: 14,
    dy: 0,
    anchor: 'start'
  },
  VN: {
    dx: -10,
    dy: 14,
    anchor: 'end'
  },
  AU: {
    dx: 14,
    dy: 2,
    anchor: 'start'
  },
  'china-beijing': {
    dx: 14,
    dy: -10,
    anchor: 'start'
  },
  'china-shanghai': {
    dx: 16,
    dy: 6,
    anchor: 'start'
  },
  'china-shenzhen': {
    dx: -10,
    dy: 12,
    anchor: 'end'
  },
  hongkong: {
    dx: 14,
    dy: -2,
    anchor: 'start'
  },
  macau: {
    dx: 10,
    dy: 14,
    anchor: 'start'
  },
  taiwan: {
    dx: 12,
    dy: 6,
    anchor: 'start'
  },
  japan: {
    dx: 12,
    dy: 0,
    anchor: 'start'
  },
  korea: {
    dx: 12,
    dy: -10,
    anchor: 'start'
  },
  singapore: {
    dx: 14,
    dy: 12,
    anchor: 'start'
  },
  malaysia: {
    dx: -14,
    dy: 10,
    anchor: 'end'
  },
  philippines: {
    dx: 14,
    dy: 0,
    anchor: 'start'
  },
  vietnam: {
    dx: -10,
    dy: 14,
    anchor: 'end'
  },
  australia: {
    dx: 14,
    dy: 2,
    anchor: 'start'
  }
};

export const getServiceMapLabelPreset = (id) => serviceMapLabelPresets[id] || null;
